import { ButtonType, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogType } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { CommonStyles } from '../../../common/react/CommonStyles';
import { ModalInstance, ReactModalOptions, ReactModalService } from '../../../commonInfra/dialogs/ReactModalService';
import { cssClass } from '../../../style';

const DIALOG_WIDTH = 400;
const ACTION_DIALOG_TESTID = 'confirm-drag-order-dialog';

export namespace ConfirmDragDropOrderDialog {

  export type ConfirmOrCancel = 'confirm' | 'cancel';

  export interface ContentOptions {
    title: string;
    message: string;
  }

  const Header = cssClass(ACTION_DIALOG_TESTID, 'header', {
    fontSize: '20px',
    lineHeight: 'normal',
    paddingBottom: 6
  });

  const Contents  = (props: { message: string }) => {
    return (
      <>
        <div>{props.message}</div>
      </>
    );
  };

  interface FooterProps {
    onCancel: () => void;
    onOk: () => void;
  }
  const Footer = (props: FooterProps) => {
    return <DialogFooterButtonsWidget
        buttons={[
          {
            handleClick: props.onCancel,
            buttonType: ButtonType.Outline,
            children: Messages.cancel(),
            testId: `${ACTION_DIALOG_TESTID}-cancel`,
          },
          {
            handleClick: props.onOk,
            buttonType: ButtonType.Primary,
            children: Messages.orderFavoritesConfirmDialogConfirm(),
            testId: `${ACTION_DIALOG_TESTID}-ok`,
          },
        ]}
        testId={`${ACTION_DIALOG_TESTID}-footer`}
      />;
  };

  export function Options(onCancel: () => void, onOk: () => void, options: ContentOptions): ReactModalOptions {
    return {
      title: options.title,
      testId: ACTION_DIALOG_TESTID,
      type: DialogType.LightweightTitleBar,
      showCloseButton: false,
      positioningBehavior: DialogPositioningBehavior.Centered,
      dialogWidth: DIALOG_WIDTH,
      dialogBodyStyle: { maxWidth: DIALOG_WIDTH + 'px' },
      dialogContent: <Contents message={options.message}/>,
      dialogContentStyle: { padding: CommonStyles.Sizes.MediumSpace },
      footerContent: <Footer onCancel={onCancel} onOk={onOk}/>
    };
  }

  export function open(opts: ContentOptions) {
    let modalInstance: ModalInstance<ConfirmOrCancel>;

    const onCancel = (): void => {
      modalInstance && modalInstance.close('cancel');
    };
    const onOk = (): void => {
      modalInstance && modalInstance.close('confirm');
    };

    modalInstance = ReactModalService.open(Options(onCancel,onOk,opts));
    return modalInstance.result;
  }
}
